import * as actionTypes from "../../constants/actionTypes";

const defaultState = 1;

const offerResultsPagination = (state = defaultState, action) => {
  switch (action.type) {
    case actionTypes.RESET_OFFER_RESULTS_PAGINATION:
      return defaultState;
    case actionTypes.UPDATE_OFFER_RESULTS_PAGINATION:
      return action.currentPage;
    default:
      return state;
  }
};

export default offerResultsPagination;
